/**
 * 토큰 갱신(reissue) 대기 큐 — 동시에 401을 받은 여러 요청 중 하나("리더")만 실제로
 * reissue를 시도하고, 나머지("팔로워")는 여기 큐에 쌓여 리더의 결과를 기다린다.
 *
 * 🔴 TRAD-3109 — 종전엔 subscriber가 성공 콜백(`(token: string) => void`) 하나뿐이었다.
 * 리더의 reissue가 **실패**하면 그 실패를 팔로워에게 전달할 방법이 없어(reject 콜백 자체가
 * 없었다) 팔로워들의 Promise가 **영원히 pending**으로 남았다 — react-query 관점에서는
 * `isLoading`이 영원히 true라 화면이 스켈레톤에 갇힌다(비로그인으로 `/user/:userId`를 열면
 * memberInfo·followers·followees 세 쿼리가 동시에 401을 받고, 그중 팔로워가 된 요청이 이렇게
 * 멈췄다 — designer 실측 91초, 사실상 무한). 성공/실패 둘 다 반드시 결판나야 하므로 subscriber를
 * `{ resolve, reject }` 쌍으로 바꾼다.
 */
export type RefreshSubscriber = {
  resolve: (token: string) => void;
  reject: (error: unknown) => void;
};

// 토큰 갱신 성공 시 대기 중인 요청 전부 재시도
export const onRefreshed = (token: string, subscribers: RefreshSubscriber[]) => {
  subscribers.forEach(({ resolve }) => resolve(token));
  subscribers.length = 0;
};

// TRAD-3109 — 토큰 갱신 실패 시 대기 중인 요청 전부 리더와 같은 에러로 reject한다.
// 호출 안 하면 팔로워 Promise가 영원히 pending으로 남는다(위 설명 참조).
export const onRefreshFailed = (error: unknown, subscribers: RefreshSubscriber[]) => {
  subscribers.forEach(({ reject }) => reject(error));
  subscribers.length = 0;
};

// 토큰 갱신 대기 큐에 추가
export const addRefreshSubscriber = (subscriber: RefreshSubscriber, subscribers: RefreshSubscriber[]) => {
  subscribers.push(subscriber);
};
